import * as Sentry from '@sentry/react';
import { ReactNode } from 'react';
import { useLocation } from 'react-router-dom';
import { RouteErrorFallback } from './RouteErrorFallback';

interface RouteErrorBoundaryProps {
  children: ReactNode;
}

export function RouteErrorBoundary({ children }: RouteErrorBoundaryProps) {
  const location = useLocation();

  return (
    <Sentry.ErrorBoundary
      key={location.pathname}
      fallback={({ error, resetError }) => (
        <RouteErrorFallback error={error} resetError={resetError} />
      )}
      beforeCapture={(scope) => {
        scope.setTag('errorBoundary', 'route');
        scope.setTag('route', location.pathname);
      }}
    >
      {children}
    </Sentry.ErrorBoundary>
  );
}
